// extracted by mini-css-extract-plugin
export default {"container":"e3O5v7","tabsHeader":"yhonTJ","pageTitle":"eNjSjf","results":"UKP1y1","editRecordTitleContainer":"S0nRzJ","buttons":"yK12Ze"};